import { Box } from '@mui/material';
import React from 'react';
import FieldError from './FieldError';
import ArrayField from './fields/ArrayField';
import BooleanField from './fields/BooleanField';
import EnumField from './fields/EnumField';
import NumberField from './fields/NumberField';
import ObjectField from './fields/ObjectField';
import StringField from './fields/StringField';

const FormField = ({
  name,
  schema,
  value,
  onChange,
  onBlur = () => {},
  error,
  touched,
  required = false,
  customComponents,
}) => {
  const commonProps = {
    name,
    schema,
    value,
    onChange,
    onBlur,
    error,
    touched,
    required,
    customComponents,
  };

  let FieldComponent;
  switch (schema.type) {
    case 'string':
      FieldComponent = schema.enum ? EnumField : StringField;
      break;
    case 'number':
    case 'integer':
      FieldComponent = NumberField;
      break;
    case 'boolean':
      FieldComponent = BooleanField;
      break;
    case 'array':
      FieldComponent = ArrayField;
      break;
    case 'object':
      FieldComponent = ObjectField;
      break;
    default:
      return <div>Unsupported field type: {schema.type}</div>;
  }

  const CustomComponent = customComponents && customComponents[name];
  const ComponentToRender = CustomComponent || FieldComponent;

  // Single Stack child so form gap is one-per-field (Fragment would split).
  return (
    <Box className="canvas-form-field" sx={{ width: '100%', minWidth: 0 }}>
      <ComponentToRender {...commonProps} />
      <FieldError error={error} touched={touched} />
    </Box>
  );
};

export default React.memo(FormField);
